{
  "(optional)": "(volitelně)",
  "(required)": "(požadováno)"
}